module.exports = __webpack_public_path__ + "static/Tanti-474312bfdd87d49201873775766adfb1.jpg";